/* eslint-disable @typescript-eslint/no-explicit-any */
import { RawEditorOptions } from "tinymce";

export function getInitialHeight(): number {
  const width = window.innerWidth;

  if (width <= 600) {
    return 400;
  } else if (width <= 960) {
    return 375;
  }

  return 250;
}

export const editorContentStyleNoPadding: string = `
body {
  font-size: 14pt;
  margin: 16px;
}

body::before {
  white-space: pre-wrap !important;
  pointer-events: none;
}

.mce-content-body li[style*="text-align: center"] {
  text-align: center !important;
  list-style-position: inside !important;
}

.mce-content-body li[style*="text-align: left"] {
  text-align: left !important;
  list-style-position: inside !important;
}

.mce-content-body li[style*="text-align: right"] {
  text-align: right !important;
  list-style-position: inside !important;
}

`;

export const editorContentStyle: string = `
body {
  font-size: 14pt;
  margin: 16px;
}

body::before {
  white-space: pre-wrap !important;
  pointer-events: none;
}

.mce-content-body li[style*="text-align: center"] {
  text-align: center !important;
  list-style-position: inside !important;
}

.mce-content-body li[style*="text-align: left"] {
  text-align: left !important;
  list-style-position: inside !important;
}

.mce-content-body li[style*="text-align: right"] {
  text-align: right !important;
  list-style-position: inside !important;
}
`;

export const BenefitsEditorConfig: RawEditorOptions | any = {
  height: getInitialHeight(),
  placeholder: "How did this activity benefit the service user...",
  browser_spellcheck: true,
  branding: false,
  menubar: false,
  paste_data_images: false,
  content_style: editorContentStyle,
  plugins: ["autolink", "wordcount", "lists", "code"],
  invalid_styles: {
    "*": "color line-height mso-outline-level background font-family",
  },
  fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
  toolbar: [
    "undo redo | fontsize | bold italic underline strikethrough | bullist numlist alignleft aligncenter alignright",
  ],
  mobile: {
    toolbar_mode: "sliding",
  },
  license_key: "gpl",
};

export const ReflectionsEditorConfig: RawEditorOptions | any = {
  height: getInitialHeight(),
  placeholder: "What do you want to say about this piece of evidence...",
  browser_spellcheck: true,
  branding: false,
  menubar: false,
  paste_data_images: false,
  content_style: editorContentStyle,
  plugins: ["autolink", "wordcount", "lists"],
  invalid_styles: {
    "*": "color line-height mso-outline-level background font-family",
  },
  fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
  toolbar: [
    "undo redo | fontsize | bold italic underline strikethrough | bullist numlist alignleft aligncenter alignright",
  ],
  mobile: {
    toolbar_mode: "sliding",
  },
  license_key: "gpl",
};

export const ObjectivesEditorConfig: RawEditorOptions | any = {
  height: getInitialHeight(),
  placeholder: "What were the learning objectives...",
  browser_spellcheck: true,
  branding: false,
  menubar: false,
  paste_data_images: false,
  content_style: editorContentStyle,
  plugins: ["autolink", "wordcount", "lists", "code"],
  invalid_styles: {
    "*": "color line-height mso-outline-level background font-family",
  },
  fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
  toolbar: [
    "undo redo | fontsize | bold italic underline strikethrough | bullist numlist alignleft aligncenter alignright",
  ],
  mobile: {
    toolbar_mode: "sliding",
  },
  license_key: "gpl",
};

export const SUMMARY_OF_WORK_MAX_WORD_COUNT = 500;
export const PERSONAL_STATEMENT_MAX_WORD_COUNT = 1500;
export const EDITOR_BOTTOM_MARGIN = 220;
export const EDITOR_AUTORESIZE_BOTTOM_MARGIN = 4;
